import { createAction, createAsyncAction } from "typesafe-actions";

import MapTool from "@mapmycustomers/shared/enum/map/MapTool";
import { Lead, MapEntity } from "@mapmycustomers/shared/types/entity";
import { Cluster, EntityPin, MapEntitiesSet, MultiPin } from "@mapmycustomers/shared/types/map";
import RangeModel from "@mapmycustomers/shared/types/viewModel/internalModel/RangeModel";

import GeoPath from "@app/types/GeoPath";
import { MapFetcherPayload } from "@app/types/map/MapFetcher";
import RulerPath from "@app/types/map/RulerPath";

export const setRouteTool = createAction("route/routeDetails/setTool")<MapTool | undefined>();

export const setRouteRulerPath = createAction("route/routeDetails/setRulerPath")<RulerPath>();

export const toggleRouteRulerPin = createAction("route/routeDetails/toggleRulerPin")<
  EntityPin | Lead | MultiPin
>();

export const appendRouteLassoPath = createAction("route/routeDetails/lasso/appendPath")<GeoPath>();
export const cleanRouteLassoPaths = createAction("route/routeDetails/lasso/cleanPaths")<void>();
export const setRouteLassoContainsFlags = createAction(
  "route/routeDetails/lasso/setContainsFlags"
)<{ containsClusters: boolean }>();
export const updateRouteLassoClusters = createAction("route/routeDetails/lasso/updateClusters")<
  Cluster[] | undefined
>();

export const enterRouteLassoMode = createAction("route/routeDetails/lasso/enter")<void>();
export const exitRouteLassoMode = createAction("route/routeDetails/lasso/exit")<void>();
export const refreshRouteLassoMode = createAction("route/routeDetails/lasso/refresh")<void>();

export const fetchRouteLassoSelection = createAsyncAction(
  "route/routeDetails/lasso/fetchSelection/request",
  "route/routeDetails/lasso/fetchSelection/success",
  "route/routeDetails/lasso/fetchSelection/failure"
)<MapFetcherPayload, void, unknown>();

// Paginated BE fetch for records displayed in the lasso sidebar list.
// Mirrors Map's fetchRecords (scene/map/store/actions): the lasso compute populates
// selected.items/selected.entities for the FULL set, while this action populates
// recordsList.records with one paginated page at a time for display.
export const fetchRouteLassoRecords = createAsyncAction(
  "route/routeDetails/lasso/fetchRecords/request",
  "route/routeDetails/lasso/fetchRecords/success",
  "route/routeDetails/lasso/fetchRecords/failure"
)<
  { range?: RangeModel; search?: string },
  { records: MapEntity[]; totalRecords: number },
  unknown
>();

// Selection mutations (Phase 3a: only setRouteSelection, setRouteSelectionEntities,
// restartRouteSelection, clearRouteSelection are dispatched. Phase 3b adds
// addToRouteSelection / removeFromRouteSelection.)
export const setRouteSelection = createAction("route/routeDetails/setSelection")<MapEntitiesSet>();
export const setRouteSelectionEntities = createAction("route/routeDetails/setSelectionEntities")<
  MapEntity[]
>();
export const restartRouteSelection = createAction("route/routeDetails/restartSelection")<void>();
export const clearRouteSelection = createAction("route/routeDetails/clearSelection")<void>();

export const addToRouteSelection = createAction("route/routeDetails/addToSelection")<
  MapEntitiesSet | string
>();

export const removeFromRouteSelection = createAction("route/routeDetails/removeFromSelection")<
  MapEntitiesSet | string
>();
